import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

import AsideView from '@uicomponents/AsideView';

import TransportEquipmentForm from './TransportEquipmentForm';

class TransportEquipmentFormPage extends Component {
  render() {
    const { t, goods, headerName } = this.props;

    return (
      <AsideView>
        <div className="step-form" key={`${goods.id}-${goods.versionNumber}-${goods.nonce}`}>
          <form className="form active no-padding-top">
            <h1 className="center">
              {headerName ? headerName : t('transportEquipment.create.header')}
            </h1>
            <TransportEquipmentForm {...this.props} />
          </form>
        </div>
      </AsideView>
    );
  }
}
export default withTranslation('translation')(TransportEquipmentFormPage);
